module.exports = __webpack_public_path__ + "static/software5-f30aee52607429436af23a48362a8fd5.jpg";